import { render } from "./SliderProductHome.vue?vue&type=template&id=139df954&scoped=true"
import script from "./SliderProductHome.vue?vue&type=script&lang=js"
export * from "./SliderProductHome.vue?vue&type=script&lang=js"

import "./SliderProductHome.vue?vue&type=style&index=0&id=139df954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139df954"]])

export default __exports__